import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_ROLES_LOAD,
    ACTION_ROLES_LOAD_BY_ID,

    ACTION_ROLES_SAVE,

    ACTION_ROLES_CREATE,

    ACTION_ROLES_VALIDATE,

    IRoleLoadAction,
    IRoleLoadByIdAction,
    IRoleLoadFailureAction,
    IRoleLoadSuccessAction,

    IRoleSaveAction,
    IRoleSaveSuccessAction,
    IRoleSaveFailureAction,

    IRoleCreateAction,
    IRoleCreateSuccessAction,
    IRoleCreateFailureAction,

    IRoleValidateAction,
    IRoleValidateSuccessAction,
    IRoleValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/role";
import { rolesApi } from "../services/roles";


export const
    getRolesEpic = (action$): Observable<IRoleLoadSuccessAction | IRoleLoadFailureAction> => {
        return action$
            .ofType(ACTION_ROLES_LOAD)
            .mergeMap((_action: IRoleLoadAction) => {
                return rolesApi
                    .getRoles()
                    .map(response =>
                        LoadSuccess(response.roles, undefined, [], response.lookups, response.modules, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getRoleByIdEpic = (action$): Observable<IRoleLoadSuccessAction | IRoleLoadFailureAction> => {
        return action$
            .ofType(ACTION_ROLES_LOAD_BY_ID)
            .mergeMap((action: IRoleLoadByIdAction) => {
                return rolesApi
                    .getRoleById(action.id)
                    .map(response =>
                        LoadSuccess(response.role, response.formState, response.formProperties, response.lookups, [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setRoleEpic = (action$): Observable<IRoleSaveSuccessAction | IRoleSaveFailureAction> => {
        return action$
            .ofType(ACTION_ROLES_SAVE)
            .mergeMap((action: IRoleSaveAction) => {
                return rolesApi
                    .setRole(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.role, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createRoleEpic = (action$): Observable<IRoleCreateSuccessAction | IRoleCreateFailureAction> => {
        return action$
            .ofType(ACTION_ROLES_CREATE)
            .mergeMap((_action: IRoleCreateAction) => {
                return rolesApi
                    .createRole()
                    .map(response =>
                        CreateSuccess(
                            response.role,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateRoleEpic = (action$): Observable<IRoleValidateSuccessAction | IRoleValidateFailureAction> => {
        return action$
            .ofType(ACTION_ROLES_VALIDATE)
            .mergeMap((action: IRoleValidateAction) => {
                return rolesApi
                    .validateRole(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.role, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }



